import { useState } from "react";

import { Option, Select } from "#ui/select";

import { FactsetIds } from "./factset-ids";
import { type ConfigItem, FactSetWidget } from "./FactsetWidget";

type Markets = typeof FactsetIds.markets;
type Market = Markets[keyof Markets];

const widget = "stock-top-flop";

interface StockTopFlopProps {
  type?: "top" | "flop" | "gainers" | "losers";
  valueBarRange?: "relative" | "absolute";
  symbolLinkClick?: (event: any) => void;
}

export function StockTopFlop({
  type = "top",
  valueBarRange = "relative",
  symbolLinkClick,
}: StockTopFlopProps) {
  const [value, setValue] = useState<Market>(FactsetIds.markets.NYSE);

  const config = [
    { type: "attribute", key: "type", value: type },
    { type: "attribute", key: "valueBarRange", value: valueBarRange },
    { type: "attribute", key: "identifierEmitted", value: "tickerRegion" },
    {
      type: "attribute",
      key: "criteria",
      value: {
        markets: [Number(value)],
        countries: [FactsetIds.countries.USA],
      },
    },
  ] as ConfigItem[];

  if (symbolLinkClick) {
    config.push({ type: "event", key: "row-click", value: symbolLinkClick });
  }

  const nameOrId = `${widget}-${type}`;
  const labelId = `${nameOrId}-label`;

  return (
    <>
      <div className="pb-20px md:max-w-240px">
        <span id={labelId} className="sr-only">
          Market
        </span>
        <Select
          name={nameOrId}
          value={value}
          onValueChange={(value: Market) => setValue(value)}
          aria-labelledby={labelId}
        >
          <Option value={FactsetIds.markets.NYSE}>NYSE</Option>
          <Option value={FactsetIds.markets.AMEX}>AMEX</Option>
          <Option value={FactsetIds.markets.Nasdaq}>Nasdaq</Option>
        </Select>
      </div>
      <FactSetWidget config={config} widget={widget} />
    </>
  );
}
